import queryString from 'query-string'

export default function cookieExists(cookies) {
    let value = false

    if (typeof document !== 'undefined') {
        cookies.forEach(function (cookie) {
            const regEx = new RegExp(cookie + '=([^;]+)')
            regEx.exec(document.cookie) ? (value = true) : false
        })
    }

    return value
}

export const tryGetLoginModeFromRequest = (params, messages) => {
    let mode

    if (params?.mode) {
        mode = params.mode
    } else if (params?.redirect) {
        const parsedUrl = queryString.parseUrl(params.redirect)
        mode = parsedUrl?.query?.mode
    }

    if (mode) {
        return messages?.loginAdditionalMessages?.[mode]?.message()
    }
}

export const adapterGetMessagesByRoute = (route) => {
    const treatedRoute = route.replace(/[-]/g, '')
    const allMessages = {
        orders: 'myorders',
        details: 'accountdetails',
        addresses: 'addressBook',
        savedcards: 'savedcards',
        credits: 'credits',
        marketingpreferences: 'emailPreferences',
        privacy: 'privacy',
        eippreview: 'eipprivileges',
    }
    return allMessages[treatedRoute]
}

export const getTitles = (mainTitle, subTitle) => {
    let titles = []
    if (mainTitle) {
        titles.push(mainTitle())
    }
    if (subTitle) {
        titles.push(subTitle())
    }

    return {
        titles,
        fullTitle: titles.length > 1 ? `${titles[0]} | ${titles[1]}` : titles[0] || '',
    }
}

export const getMetaData = (messages, location, brandId) => {
    const { pathname = '' } = location
    const baseUrl = '/account/'
    const baseUrlStartIndex = pathname.indexOf(baseUrl)
    const currentRoute =
        baseUrlStartIndex !== -1
            ? pathname.substring(baseUrlStartIndex + baseUrl.length).replace(/(?=[?/]).+/g, '')
            : baseUrl
    const { metaData, pages } = messages

    const defaultMetaData = metaData['default'] || {}
    const pageMetaData = pages[adapterGetMessagesByRoute(currentRoute)]

    const mainTitle = pageMetaData?.title
    const subTitle = defaultMetaData?.title

    const { titles, fullTitle } = getTitles(mainTitle, subTitle)

    return {
        brandId,
        description: defaultMetaData?.description(),
        keywords: defaultMetaData?.keywords(),
        robots: 'noindex,follow',
        titles,
        fullTitle,
        titleDelimiter: '|',
        og: {
            title: fullTitle || defaultMetaData?.title(),
            description: pageMetaData?.description(),
        },
    }
}
